import {PlanLimits} from "@/lib/types/accounts.ts";
import {Plan} from "@/lib/types/billing.ts";

export const PURCHASE_ITEM_NAMES: Record<keyof PlanLimits | "annual_billing", string> = {
  limit_api_checks: "API Check",
  limit_basic_checks: "Basic Check",
  limit_advanced_checks: "Advanced Check",
  limit_cloudstatus_checks: "Cloud Status Check",
  limit_custom_checks: "Custom Check",
  limit_group_checks: "Group Check",
  limit_history: "History Retention Week",
  limit_monitoring_group_level: "Check Location",
  limit_monitoring_groups: "Locations Per Check",
  limit_multi_users: "User Account",
  limit_pagespeed_checks: "Page Speed Check",
  limit_phonecalls: "Monthly Phone Credit",
  limit_private_locations: "Private Location",
  limit_rum_checks_requests_per_month: "RUM data point",
  limit_sms: "Monthly SMS Credit",
  limit_sms_and_phone_alerts: "Monthly SMS And Phone Alert",
  limit_statuspage_subscriptions: "Status Page Subscriber",
  limit_statuspages: "Status Page",
  limit_statuspages_external_user: "Status Page External User",
  limit_transaction_checks: "Transaction Check",
  limit_check_frequency: "Minimum Check Frequency",
  annual_billing: "Move to Annual Billing",
};

export const ADDON_SECTIONS = [
  {
    title: "Basic and Advanced Monitoring",
    subtitle: "Comprehensively monitor downtime, performance, and experience of public and internal websites.",
    fields: [
      "limit_basic_checks",
      "limit_transaction_checks",
      "limit_pagespeed_checks",
      "limit_rum_checks_requests_per_month",
      "limit_api_checks",
      "limit_custom_checks",
      "limit_group_checks",
      "limit_cloudstatus_checks",
      "limit_private_locations",
    ],
  },
  {
    title: "Downtime and Performance Alerts",
    subtitle: "Deliver accurate and immediate notifications through call, text, email, and popular DevOps tools.",
    fields: ["limit_sms", "limit_phonecalls"],
  },
  {
    title: "Public and Private Status Pages",
    subtitle: "Launch branded, professional pages for incident communication with users, teams, and subscribers.",
    fields: ["limit_statuspages", "limit_statuspages_external_user", "limit_statuspage_subscriptions"],
  },
  {
    title: "Account and Settings",
    subtitle: "Customize Your Account and Manage System Preferences.",
    fields: ["limit_multi_users"],
  },
];

export const PLAN_FIELD_TOOLTIPS: Record<string, string | Record<Plan, string>> = {
  limit_basic_checks: "Continuously test website, network, and email server performance.",
  limit_transaction_checks: "Mimic user actions to test forms and flows like login and checkout.",
  limit_api_checks: "Test APIs with multiple HTTP(S) requests, custom headers and tokens.",
  limit_pagespeed_checks: {
    [Plan.Starter]:
      "Test website performance on scheduled intervals. Starter plan limits frequency and number " +
      "of locations. Upgrade to Essential for additional PageSpeed tests.",
    [Plan.Essential]: "Test website performance on scheduled intervals.",
    [Plan.Premium]: "Test website performance on scheduled intervals.",
    [Plan.Custom]: "Test website performance on scheduled intervals.",
  },
  limit_cloudstatus_checks: "Monitor the status of common cloud services.",
  limit_group_checks: "Organize, monitor, alert, and report on the overall performance ",
  limit_statuspages: "Customizable reporting for downtime, alerts, checks, and more.",
  limit_multi_users: "The total number of available platform login seats.",
  limit_monitoring_group_level:
    "To see the whole list of available locations please visit our Probe Servers page inside the product UI.",
  limit_monitoring_groups: "The number of probe servers locations configurable per check.",
  limit_check_frequency:
    "The minimum check frequency available for checks. Some advanced checks have higher frequency. " +
    "See our full Feature Comparison below.",
  limit_rum_checks_requests_per_month: "Monitor site load time, errors, and performance with real user sessions.",
  limit_phonecalls: "Get automated call alert notifications",
  limit_sms: "Get text message alert notifications",
  limit_custom_checks: "Perform complex API checks against REST API endpoints.",
  limit_statuspage_subscriptions: "Number of Email & SMS Subscribers available on StatusPage.",
  limit_private_locations: "Number of Private Locations available for monitoring.",
};
